var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value == 0)?_c('span'):(_vm.value === true)?_c('span',[_vm._v("true")]):(_vm.value === false)?_c('span',[_vm._v("false")]):_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.value,'', 1)))])
}
var staticRenderFns = []

export { render, staticRenderFns }